(function () {
  'use strict';

  var rootSelector = '.js-filter-drawer';
  var drawerSelector = '.m-filter-drawer';
  var visibleClass = 'm-filter-drawer--visible';

  function setBodyState(isOpen) {
    document.body.classList.toggle('no-scroll', isOpen);
    document.body.classList.toggle('filter-sidebar--open', isOpen);

    if (isOpen) {
      window.setTimeout(function () {
        document.body.classList.add('filter-sidebar--is-animating');
      }, 600);
    } else {
      document.body.classList.remove('filter-sidebar--is-animating');
    }
  }

  function setDrawerState(root, isOpen) {
    var drawer = root.querySelector(drawerSelector);

    if (!drawer) {
      return;
    }

    drawer.classList.toggle(visibleClass, isOpen);
    setBodyState(isOpen);
  }

  function toggleDrawer(root) {
    var drawer = root.querySelector(drawerSelector);
    var isOpen = drawer && drawer.classList.contains(visibleClass);

    setDrawerState(root, !isOpen);
  }

  function handleKeyup(event, callback) {
    if (event.key === 'Enter' || event.code === 'Space') {
      event.preventDefault();
      callback();
    }
  }

  function init() {
    document.querySelectorAll(rootSelector).forEach(function (root) {
      if (root.dataset.filterDrawerInitialised === 'true') {
        return;
      }

      var trigger = root.querySelector('.js-filter-drawer-trigger');
      var underlay = root.querySelector('.js-filter-drawer-underlay');
      var closeButtons = root.querySelectorAll('.js-filter-drawer-close');

      if (!trigger || !underlay) {
        return;
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        toggleDrawer(root);
      });
      trigger.addEventListener('keyup', function (event) {
        handleKeyup(event, function () { toggleDrawer(root); });
      });

      underlay.addEventListener('click', function (event) {
        event.preventDefault();
        setDrawerState(root, false);
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          setDrawerState(root, false);
        });
        button.addEventListener('keyup', function (event) {
          handleKeyup(event, function () { setDrawerState(root, false); });
        });
      });

      root.dataset.filterDrawerInitialised = 'true';
    });
  }

  window.addEventListener('load', init, false);
  window.addEventListener('shopify:section:load', init, false);
  init();
}());
